import { createFileRoute } from '@tanstack/react-router';

import { DiamondsPage, diamondsSearchSchema } from '@/features/diamonds';

/** Every platform role reads the pool; owners and admins edit suppliers and load stones. */
export const Route = createFileRoute('/_authed/diamonds')({
  staticData: { crumbKey: 'nav.diamonds', tours: ['platform.diamonds'] },
  validateSearch: diamondsSearchSchema,
  component: DiamondsPage,
});
